import { BotNotFound, Collapsible, PageSpinner } from "./components.tsx";
import { useQuery } from "./db.ts";
import {
  BlockedUsersEditor,
  BotDeprecationNoticeEditor,
  BotErrorMessageEditor,
  BotPromptEditor,
  BotSettingsToggles,
  BotTimezoneEditor,
  GroupChatBehaviorSelector,
  PreferredProviderSelector,
} from "./basicConfigPartials.tsx";

export const PromptConfig = ({ id }: { id: string }) => {
  const { data, isLoading, error } = useQuery({
    bots: { $: { where: { id } } },
  });

  if (isLoading) return <PageSpinner />;
  if (error) return error.message;
  const [bot] = data.bots;
  if (!bot) return <BotNotFound />;

  const {
    prompt,
    promptHistory,
  } = bot;

  return (
    <Collapsible
      title="Prompt & Instructions"
      style={{ display: "flex", flexDirection: "column", gap: 8 }}
    >
      <BotPromptEditor
        botId={bot.id}
        prompt={prompt}
        promptHistory={promptHistory}
      />
    </Collapsible>
  );
};

export const BehaviorConfig = ({ id }: { id: string }) => {
  const { data, isLoading, error } = useQuery({
    bots: { $: { where: { id } } },
  });

  if (isLoading) return <PageSpinner />;
  if (error) return error.message;
  const [bot] = data.bots;
  if (!bot) return <BotNotFound />;

  const {
    timezoneIANA,
    errorMessage,
    deprecationNotice,
    groupChatBehavior,
    preferredProvider,
    blockedUsers,
  } = bot;

  return (
    <Collapsible
      title="Behaviour"
      style={{ display: "flex", flexDirection: "column", gap: 8 }}
    >
      <BotTimezoneEditor botId={bot.id} timezoneIANA={timezoneIANA} />
      <BotSettingsToggles
        botId={bot.id}
        toggleValues={bot}
        fields={[
          "injectAds",
          "isolateUsers",
          "enableCodeExecution",
          "enableImageGeneration",
          "enableWebSearch",
          "enableBrowserUse",
          "enableHandoff",
          "showToolUseSpinner",
        ]}
      />
      <GroupChatBehaviorSelector
        botId={bot.id}
        groupChatBehavior={groupChatBehavior}
      />
      <PreferredProviderSelector
        botId={bot.id}
        preferredProvider={preferredProvider}
      />
      <BotErrorMessageEditor
        botId={bot.id}
        errorMessage={errorMessage}
      />
      <BotDeprecationNoticeEditor
        botId={bot.id}
        deprecationNotice={deprecationNotice}
      />
      <BlockedUsersEditor
        botId={bot.id}
        blockedUsers={blockedUsers as string[] | undefined}
      />
    </Collapsible>
  );
};
